import { FormikErrors } from 'formik'
import { TFunction } from 'i18next'

import { FilterQueryProps } from '@model/FilterFields'

import {
  EmailPattern,
  EmojiPattern,
  RestrictedSpecialCharacters,
  UrlHttpPattern,
} from './formValidation'

export const getRegexErrorMessage = (t: TFunction, validationRegex: string): string => {
  const regexMessages: Record<string, string> = {
    '^\\d{3}$': t('Validation.Must be exactly digits', {
      length: 3,
    }),
    '^\\d{4}$': t('Validation.Must be exactly digits', {
      length: 4,
    }),
    '^\\d{5}$': t('Validation.Must be exactly digits', {
      length: 5,
    }),
    '^\\d{6}$': t('Validation.Must be exactly digits', {
      length: 6,
    }),
  }

  return regexMessages[validationRegex] || t('Validation.Invalid format')
}

export const isChinese = (text: string): boolean => {
  const rgx = /^[\u4e00-\u9fa5\u00B7]+$/
  return rgx.test(text)
}

export const isNumber = (amount: string): boolean => {
  return /^\d+(\.\d{0,2})?$/.test(amount)
}

export function removeRestrictedSpecialCharacters(v: string): string {
  return removeEmojis(v).replace(RestrictedSpecialCharacters, '')
}

export function removeEmojis(v: string | number): string {
  if (typeof v !== 'string' && typeof v !== 'number') {
    return v
  }
  return v.toString().replace(EmojiPattern, '')
}

export function minTwoDigits(n: unknown): string {
  if (typeof n !== 'number') {
    return String(n)
  }
  return (n < 10 ? '0' : '') + n
}

export function isEmailValid(email: string): boolean {
  if (!email) {
    return false
  }
  return EmailPattern.test(email)
}

export const isFullUrl = (url: string): boolean => {
  return UrlHttpPattern.test(url)
}

export const trimToMaxLength = (value: string, maxLength: number): string => {
  const trimmed = value.trim()
  return trimmed.length > maxLength ? trimmed.slice(0, maxLength) : trimmed
}

export const isOne = (value?: string | number | null): boolean => value?.toString() === '1'
export const isZero = (value?: string | number | null): boolean => value?.toString() === '0'

export const minNumber = (value: string | number, min: number): boolean => Number(value) < min
export const maxNumber = (value: string | number, max: number): boolean => Number(value) > max

export const hasArabicWithSpacesAndDashes = (text: string): boolean =>
  /^[\u0600-\u06FF\s-]+$/.test(text)

export const createAmountRangeValidator =
  (values: FilterQueryProps, errors: FormikErrors<FilterQueryProps>, t: TFunction) =>
  (fieldFrom: keyof FilterQueryProps, fieldTo: keyof FilterQueryProps): void => {
    if (!values[fieldFrom] || !values[fieldTo]) {
      return
    }

    if (Number(values[fieldFrom]) > Number(values[fieldTo])) {
      errors[fieldFrom] = t('Validation.From amount must be less or equal to to amount')
    }

    if (Number(values[fieldTo]) < Number(values[fieldFrom])) {
      errors[fieldTo] = t('Validation.To amount must be greater or equal to from amount')
    }
  }
